import { NgStyle } from '@angular/common';
import { Component, EventEmitter, inject, Input, Output } from '@angular/core';
import { faCaretDown } from '@fortawesome/pro-solid-svg-icons';
import { AaNgModule } from 'aa-ng';
import { ActivityType } from 'src/app/models';

import {
  IActivityTypeLookupType,
  IActivityYearLookupType,
  IMultiSelectItem,
} from '../../models';
import { IActivitySearchFilterCounts } from '../../models/activity-search';
import { EnumToArrayPipe } from '../../pipes';

@Component({
  selector: 'app-activity-table-filter',
  imports: [AaNgModule, NgStyle],
  templateUrl: './activity-table-filter.component.html',
})
export class ActivityTableFilterComponent {
  private enumToArray = inject(EnumToArrayPipe);

  faCaretDown = faCaretDown;

  _open = false;

  @Input()
  multiSelectActivityTypes: IMultiSelectItem<IActivityTypeLookupType>[] = [];
  @Input()
  multiSelectActivityYears: IMultiSelectItem<IActivityYearLookupType>[] = [];

  @Input() set activitySearchFilterCounts(counts: IActivitySearchFilterCounts) {
    if (counts?.activityTypes?.length) {
      const standardActivityTypes = this.enumToArray
        .transform(ActivityType)
        .map((t) => ({
          id: t.value,
          name: t.name,
        }));

      this.multiSelectActivityTypes = counts.activityTypes
        .map((x) => ({
          data: x,
          name: `${standardActivityTypes.find((t) => t.id === x.id)?.name} (${x.count})`,
          selected: false,
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
    }

    if (counts?.years?.length) {
      this.multiSelectActivityYears = counts.years
        .map((x) => ({
          data: { id: x.id, name: +x.name },
          name: `${x.name} (${x.count})`,
          selected: false,
        }))
        .sort((a, b) => a.name.localeCompare(b.name));
    }
  }

  @Output() activityTypeSelected = new EventEmitter<
    IMultiSelectItem<IActivityTypeLookupType>[]
  >();
  @Output() activityYearSelected = new EventEmitter<
    IMultiSelectItem<IActivityYearLookupType>[]
  >();

  @Output() applyButtonClicked = new EventEmitter<{
    activityTypes: IMultiSelectItem<IActivityTypeLookupType>[];
    years: IMultiSelectItem<IActivityYearLookupType>[];
  }>();
  @Output() cancelButtonClicked = new EventEmitter<void>();

  onActivityTypeSelected(
    activityType: IMultiSelectItem<IActivityTypeLookupType>,
  ) {
    activityType.selected = !activityType.selected;

    this.activityTypeSelected.emit([activityType]);
  }

  onActivityYearSelected(
    activityYear: IMultiSelectItem<IActivityYearLookupType>,
  ) {
    activityYear.selected = !activityYear.selected;

    this.activityYearSelected.emit([activityYear]);
  }

  toggleDD(open: boolean) {
    this._open = open;
  }

  cancelButtonClick() {
    this.multiSelectActivityTypes.forEach((type) => (type.selected = false));
    this.multiSelectActivityYears.forEach((year) => (year.selected = false));

    this.cancelButtonClicked.emit();
  }

  applyButtonClick() {
    this.applyButtonClicked.emit({
      activityTypes: this.multiSelectActivityTypes,
      years: this.multiSelectActivityYears,
    });
  }
}
